import { Injectable } from '@angular/core';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { 
  ODataClient,
  ODataEntityService, 
  ODataEntity, 
  ODataEntities, 
  ODataProperty, 
  EntityKey,
  Duration,
  ODataEntityResource,
  ODataEntitySetResource,
  ODataNavigationPropertyResource,
  ODataActionResource,
  ODataFunctionResource,
  HttpOptions
} from 'angular-odata';

//#region ODataApi Imports
import { Asset } from '../entities/assets/asset.entity';
import { AssetMetaData } from '../entities/assets/assetmetadata.entity';
import { MetaData } from '../entities/assets/metadata.entity';
import { Property } from '../entities/ref/property.entity';
import { Status } from '../entities/settings/status.entity';
import { StatusType } from '../entities/settings/statustype.entity';
//#endregion

@Injectable()
export class AssetMetaDataService extends ODataEntityService<AssetMetaData> {
  constructor(protected client: ODataClient) {
    super(client, 'AssetMetaData', 'entities.assets.AssetMetaData');
  }

  
  
  //#region ODataApi Actions
  //#endregion
  //#region ODataApi Functions
  //#endregion
  //#region ODataApi Navigations
  public asset(entity: EntityKey<AssetMetaData>): ODataNavigationPropertyResource<Asset> {
    return this.entity(entity).navigationProperty<Asset>('asset');
  }
  public metaData(entity: EntityKey<AssetMetaData>): ODataNavigationPropertyResource<MetaData> {
    return this.entity(entity).navigationProperty<MetaData>('metaData');
  }
  public property(entity: EntityKey<AssetMetaData>): ODataNavigationPropertyResource<Property> {
    return this.entity(entity).navigationProperty<Property>('property');
  }
  public status(entity: EntityKey<AssetMetaData>): ODataNavigationPropertyResource<Status> {
    return this.entity(entity).navigationProperty<Status>('status');
  }
  public statusType(entity: EntityKey<AssetMetaData>): ODataNavigationPropertyResource<StatusType> {
    return this.entity(entity).navigationProperty<StatusType>('statusType');
  }
  //#endregion
}
